import type { IconName } from '@/shared/ui/icon';

/**
 * Maps a nav item key to its semantic icon. Shared so the sidebar rail and the
 * top-bar search show the SAME glyph for a destination.
 */
export const NAV_ICON_NAMES: Record<string, IconName> = {
  workspace: 'dashboard',
  profile: 'user',
  'smart-profile': 'sparkles',
  'cv-intelligence': 'file-text',
  'job-matches': 'brain',
  applications: 'briefcase',
  company: 'building',
  'employer-dashboard': 'dashboard',
  'company-profile': 'building',
  jobs: 'briefcase',
  'employer-applications': 'clipboard-list',
  'find-candidates': 'search',
  settings: 'settings',
  admin: 'shield',
  'admin-dashboard': 'dashboard',
  'admin-users': 'users',
  'admin-roles': 'shield',
  'admin-plans': 'credit-card',
  'admin-ai-usage': 'brain',
  'admin-early-access': 'mail',
  'admin-settings': 'sliders',
  'admin-audit-logs': 'audit',
};

export function navIconName(key: string): IconName {
  return NAV_ICON_NAMES[key] ?? 'dashboard';
}

export type NavSection = 'workspace' | 'employer' | 'admin';

const EMPLOYER_KEYS = new Set([
  'company',
  'employer-dashboard',
  'company-profile',
  'jobs',
  'employer-applications',
  'find-candidates',
]);

/** Coarse grouping of a nav item into a search-tree section. */
export function navSection(key: string): NavSection {
  if (key.startsWith('admin')) return 'admin';
  if (EMPLOYER_KEYS.has(key)) return 'employer';
  return 'workspace';
}
